<template>
    <div v-show="isAddLicenseFailedModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
                    <div class="modal-content p-2">
                        <div class="modal-header">
                            <div class="maheading_2">
                                <h5 class="modal-title">Purchase {{ unitType }}s</h5>
                            </div>
                            <div class="maheading_3">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="successPanel">
                                        <div class="success_col_1">
                                            <p class="success-note">
                                                Your payment transaction has failed. Please try again.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-md-center closebtn_div">
                                <div class="col-12 text-center">
                                    <button type="button" class="btn btn-sm closeBtn text-center" @click="closeModal">Close Window</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: ['isAddLicenseFailedModalVisible', 'landingPage', 'unitType'],
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        hide() {
            this.closeModal();
        },
        closeModal() {
            let routeData = this.$router.resolve({name: this.landingPage});
            window.open(routeData.href, '_self');
        },
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 80%; }
.maheading_3 { width: 20%; }
.successPanel { 
    padding: 20px;
    border-radius: 10px;
}
.success-note { font-size: 1.05rem; text-align: center; margin: 2rem 0; color: #dc3545; font-weight: 900; }
.success_col_1 { width: 100%; text-align: center;}
.closebtn_div { margin: 8rem; }
</style>



// WEBPACK FOOTER //
// src/components/manager/add_license_failed_modal.vue